import { Box } from "@material-ui/core"
import { tableStyles } from "../../styles"
import { useRevenueParams } from "../../hooks/useRevenueParams"
import { DetailsGCFData, DetailsNonGCFData } from "../../types"
import { useMarketsWithRegions } from "../../hooks/useMarketsWithRegions"
import { Link } from "react-router-dom"
import { getPalette } from "../Charts/palette"
import { useMemo } from "react"
import { useGetUserInfo } from "../../hooks/useGetUserInfo"

const Dot = ({ type, rowId }: { type: string; rowId: number }) => {
  return (
    <div className={tableStyles.dotIconContainer}>
      <div
        className={tableStyles.dotIcon}
        style={{
          backgroundColor:
            rowId !== 0 ? getPalette(type)[rowId - 1] : "#6A6A6B",
        }}
      ></div>
    </div>
  )
}

interface NameProps {
  type: string
  row: DetailsNonGCFData | DetailsGCFData
  rowId: number
}

export function EntityNameRenderer({ type, row, rowId }: NameProps) {
  const { pathname, search } = useRevenueParams()
  const { marketsWithRegions } = useMarketsWithRegions()
  const newSearch = new URLSearchParams(search)
  const { isGmpUser } = useGetUserInfo()

  if (rowId !== 0) {
    switch (type) {
      case "brands":
        row.entityName && newSearch.set("brand", row.entityName)
        break
      case "clients":
        row.entityCode && newSearch.set("client", row.entityCode)
        break
      case "markets":
        row.entityName && newSearch.set("market", row.entityName)
        newSearch.set(
          "region",
          marketsWithRegions.find((x) => x.name === row.entityName)?.region ||
            "All",
        )
        break
      case "regions":
        row.entityName && newSearch.set("region", row.entityName)
        break
      case "streams":
        row.entityName && newSearch.set("brand", row.entityName)
        break
    }
  }

  const to = { pathname, search: newSearch.toString() }

  const isLinkEnabled = useMemo(() => {
    switch (type) {
      case "brands":
      case "clients":
      case "streams":
        return !isGmpUser

      default:
        return true
    }
  }, [type, isGmpUser])

  return (
    <Box alignItems="center" display="flex" textAlign="left">
      {row.entityName && <Dot type={type} rowId={rowId} />}
      {rowId !== 0 && row.entityName !== "Other" && isLinkEnabled
        ? !!row.entityName && (
            <Link className={tableStyles.cell} to={to} title={row.entityName}>
              <div className={tableStyles.truncateText}>{row.entityName}</div>
            </Link>
          )
        : row.entityName}
    </Box>
  )
}
